import { PortfolioUpdateEnum } from '@/assets/global/enums/endpoints/PortfolioUpdateEnum'
import { getDepartmentDescriptionById } from '@/utils/constants/department.model.constants'
import { useUserStore } from '@/stores/userStore'

interface Ids {
  areas?: string
}

export const RoutesRegionalAreasObject = [
  {
    regex: /^\/regional\/areas\/?$/,
    title: () => {
      const desc = getDepartmentDescriptionById(useUserStore().getRegional())
      return desc ? `Portfólio - ${desc}` : 'Portfólio'
    },
    breadcrumbTitle: 'Portfólio',
    children: [
      {
        regex: /^\/[\d+]+\/?$/,
        title: async (ids: Ids) => {
          const areaId = Number(ids.areas)
          if (!areaId || areaId <= 0) return 'Área Tecnológica'

          try {
            const { data: areaData } = (await useApiModified([
              createUrl(
                PortfolioUpdateEnum.AREA_ID.replace(
                  '{regionalAreaId}',
                  String(areaId),
                ),
              ),
            ])) as { data: any; response: any }

            return (
              areaData?.value?.data?.regionalArea?.area?.name ??
              'Área Tecnológica'
            )
          } catch {
            return 'Área Tecnológica'
          }
        },
        breadcrumb: true,
      },
    ],
  },
]

export const RoutesRegionalAreasComponents = []
